"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var metalog_1 = require("../../../../metalog/app/js/logic/metalog");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var metalog;
            (function (metalog) {
                var PortfolioChartMakerFactory = /** @class */ (function () {
                    function PortfolioChartMakerFactory() {
                    }
                    PortfolioChartMakerFactory.prototype.makePortfolioUncertaintyChartMaker = function (config, currentKeyData) {
                        return currentKeyData.shadow ?
                            new ShadowPortfolioUncertaintyChartMaker(config, currentKeyData) :
                            new PortfolioUncertaintyChartMaker(config, currentKeyData);
                    };
                    return PortfolioChartMakerFactory;
                }());
                metalog.PortfolioChartMakerFactory = PortfolioChartMakerFactory;
                var PortfolioUncertaintyChartMaker = /** @class */ (function () {
                    function PortfolioUncertaintyChartMaker(config, currentKeyData) {
                        var _this = this;
                        this.display = currentKeyData.Title;
                        this.units = currentKeyData.Units;
                        this.portfolioUncData = currentKeyData;
                        this.portfolioUncData.main.forEach(function (dataPacket) {
                            _this.addMetaLogOutputsTo(dataPacket);
                        });
                        this.config = config;
                        if (this.config.decimals == "Default") {
                            this.config.decimals = null;
                        }
                    }
                    PortfolioUncertaintyChartMaker.prototype.addMetaLogOutputsTo = function (dataPack) {
                        dataPack.metalogOutputs = this.buildOutputs(this.makeMetalogPoints(dataPack.metalog3Term.Coefficients), new metalog_1.MetaLog(dataPack.metalog3Term.Coefficients));
                        dataPack.polandOutputs = this.buildOutputs(this.makePolandPoints(dataPack.polandConstants), new metalog_1.Poland(dataPack.polandConstants));
                    };
                    PortfolioUncertaintyChartMaker.prototype.buildOutputs = function (points, distribution) {
                        return {
                            points: points,
                            mvsCalculated: new metalog_1.MVSFromDistribution(points).mvs(),
                            tenFiftyNinety: distribution.tenFiftyNinety()
                        };
                    };
                    PortfolioUncertaintyChartMaker.prototype.maxY = function (points) {
                        return points.map(function (point) {
                            return point.pdfPoint;
                        }).reduce(function (max, currentPoint) {
                            if (currentPoint.y > max) {
                                return currentPoint.y;
                            }
                            else {
                                return max;
                            }
                        }, 0);
                    };
                    PortfolioUncertaintyChartMaker.prototype.makePolandPoints = function (constants) {
                        return new metalog_1.PointProducer().thousandPointsFrom(new metalog_1.Poland(constants));
                    };
                    PortfolioUncertaintyChartMaker.prototype.makeMetalogPoints = function (coefficients) {
                        return new metalog_1.PointProducer().thousandPointsFrom(new metalog_1.MetaLog(coefficients));
                    };
                    PortfolioUncertaintyChartMaker.prototype.makeTenFiftyNinetyScatterPlot = function (chartPrefix, nodeName, color, tenFiftyNinety, yAxisTenFiftyNinetyValues) {
                        return {
                            type: 'scatter',
                            name: ' 10-50-90 Percentile (' + nodeName + ')',
                            color: color,
                            marker: {
                                radius: 5,
                                symbol: 'square',
                                lineColor: 'black',
                                fillColor: color
                            },
                            data: [
                                [tenFiftyNinety.ten, yAxisTenFiftyNinetyValues.ten],
                                [tenFiftyNinety.fifty, yAxisTenFiftyNinetyValues.fifty],
                                [tenFiftyNinety.ninety, yAxisTenFiftyNinetyValues.ninety]
                            ]
                        };
                    };
                    PortfolioUncertaintyChartMaker.prototype.addCurveAnd105090PointsTo = function (series, nodeName, color, distOutputs, extractor, distribution) {
                        series.push({
                            name: extractor.descriptor() + ' ' +
                                '(' + nodeName + ')',
                            color: color,
                            data: extractor.curveToPoints(distOutputs.points)
                        });
                        series.push(this.makeTenFiftyNinetyScatterPlot(distribution.ID(), nodeName, color, distOutputs.tenFiftyNinety, extractor.yAxisTenFiftyNinetyValues(distribution)));
                    };
                    PortfolioUncertaintyChartMaker.prototype.makeCurveAnd105090Points = function (extractor, data) {
                        var series = [];
                        if (this.config.showMetalog) {
                            this.addCurveAnd105090PointsTo(series, data.name, data.color, data.metalogOutputs, extractor, new metalog_1.MetaLog(data.metalog3Term.Coefficients));
                        }
                        if (this.config.showPoland) {
                            this.addCurveAnd105090PointsTo(series, data.name, data.color, data.polandOutputs, extractor, new metalog_1.Poland(data.polandConstants));
                        }
                        return series;
                    };
                    PortfolioUncertaintyChartMaker.prototype.makeAllSeriesForCurve = function (curveData, extractor) {
                        var _this = this;
                        var series = [];
                        var firstXValue = 1000000;
                        curveData.forEach(function (eachSeriesData) {
                            var result = _this.makeSeriesUsing(extractor, eachSeriesData);
                            var currSeries = result.series;
                            var currFirstXValue = result.firstXValue;
                            series = series.concat(currSeries);
                            firstXValue = firstXValue < currFirstXValue ? firstXValue : currFirstXValue;
                        });
                        return { series: series, firstXValue: firstXValue };
                    };
                    PortfolioUncertaintyChartMaker.prototype.makeAllSeries = function (portfolioUncData, extractor) {
                        return this.makeAllSeriesForCurve(portfolioUncData.main, extractor);
                    };
                    PortfolioUncertaintyChartMaker.prototype.draw = function (extractor) {
                        var chartMaker = this;
                        var portfolioUncData = this.portfolioUncData;
                        var allSeries = this.makeAllSeries(portfolioUncData, extractor);
                        var series = allSeries.series;
                        var firstXValue = allSeries.firstXValue;
                        var chartOptions = this.chartOptions(series, firstXValue, extractor);
                        var that = this;
                        this.chart = new Highcharts.Chart(chartOptions, function (chart) {
                            chart.renderer.text(chartMaker.getDate(), 420, 560).css({
                                color: '#939294',
                                fontSize: '10px'
                            }).add();
                            var normalState = {}, hoverState = {
                                fill: '#000000',
                                style: {
                                    color: '#FFFFFF'
                                }
                            }, pressedState = {
                                fill: '#000000',
                                style: {
                                    color: '#FFFFFF'
                                }
                            };
                            // chart.renderer.button('M', 20,10,function() {
                            //     that.toggleMetalog(extractor);
                            // }, that.config.showMetalog?pressedState:normalState, hoverState, pressedState).add();
                            // chart.renderer.button('P', 50,10,function() {
                            //     that.togglePoland(extractor);
                            // }, that.config.showPoland?pressedState:normalState, hoverState, pressedState).add();
                        });
                    };
                    PortfolioUncertaintyChartMaker.prototype.toggleMetalog = function (extractor) {
                        this.config.showMetalog = !this.config.showMetalog;
                        // console.log("Metalog: " + this.config.showMetalog);
                        this.draw(extractor);
                        this.config.apply();
                    };
                    PortfolioUncertaintyChartMaker.prototype.togglePoland = function (extractor) {
                        this.config.showPoland = !this.config.showPoland;
                        // console.log("Poland: " + this.config.showPoland);
                        this.draw(extractor);
                        this.config.apply();
                    };
                    PortfolioUncertaintyChartMaker.prototype.makeSeriesUsing = function (extractor, curveDataPackage) {
                        var series = this.makeCurveAnd105090Points(extractor, curveDataPackage);
                        var firstXValue = this.getFirstPoint(curveDataPackage.metalogOutputs.points, curveDataPackage.polandOutputs.points, extractor);
                        return { series: series, firstXValue: firstXValue };
                    };
                    PortfolioUncertaintyChartMaker.prototype.getDate = function () {
                        var dateInString = new Date().toString();
                        var splitTimestamp = dateInString.split(" ");
                        var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
                        var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
                        return "" + splitTimestamp[1] + " " + splitTimestamp[2] + " " + splitTimestamp[3] + " " + timeWithoutSec + " " + timeZone + " ";
                    };
                    PortfolioUncertaintyChartMaker.prototype.getFirstPoint = function (metalogPoints, polandPoints, extractor) {
                        return Math.min(extractor.curveToPoints(metalogPoints)[0][0], extractor.curveToPoints(polandPoints)[0][0]);
                    };
                    // private subTitle():string {
                    //     var msg = this.config.showMetalog ? 'Using the Metalog' +
                    //         ' Distribution (3 Terms)':'';
                    //     if (this.config.showPoland) {
                    //         msg += msg.length > 0 ? ' and a Poland Gaussian fit':
                    //             'Using a Poland Gaussian fit';
                    //     }
                    //     return msg;
                    // }
                    PortfolioUncertaintyChartMaker.prototype.chartOptions = function (series, firstXValue, extractor) {
                        return {
                            chart: {
                                type: 'spline',
                                zoomType: 'xy',
                                inverted: false,
                                height: 560,
                                width: 650,
                                renderTo: 'metalogChartContainer'
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: extractor.title()
                            },
                            // subtitle: {
                            //     text: this.subTitle()
                            // },
                            xAxis: {
                                min: firstXValue > 0 ? 0 : undefined,
                                reversed: false,
                                title: {
                                    enabled: true,
                                    text: this.display + ' (' + this.units + ')'
                                },
                                labels: {
                                    formatter: function () {
                                        return this.value;
                                    }
                                },
                                maxPadding: 0.05,
                                showLastLabel: true,
                                crosshair: true,
                                plotLines: [{
                                        color: '#ccd6eb',
                                        width: 1,
                                        value: 0
                                    }]
                            },
                            yAxis: extractor.yAxisDefinition(),
                            legend: {
                                enabled: true
                            },
                            tooltip: {
                                enabled: this.config.showTooltip,
                                headerFormat: '<b>{series.name}</b><br/>',
                                pointFormat: 'Value: {point.x:.' + this.config.decimals + 'f}' +
                                    extractor.yAxisDescriptor() +
                                    ': {point.y:.' + this.config.decimals + 'f}'
                            },
                            plotOptions: {
                                series: {
                                    turboThreshold: 0
                                }
                            },
                            series: series
                        };
                    };
                    return PortfolioUncertaintyChartMaker;
                }());
                metalog.PortfolioUncertaintyChartMaker = PortfolioUncertaintyChartMaker;
                var ShadowPortfolioUncertaintyChartMaker = /** @class */ (function (_super) {
                    __extends(ShadowPortfolioUncertaintyChartMaker, _super);
                    function ShadowPortfolioUncertaintyChartMaker(config, currentKeyData) {
                        var _this = _super.call(this, config, currentKeyData) || this;
                        _this.portfolioUncData.shadow.forEach(function (dataPacket) {
                            _this.addMetaLogOutputsTo(dataPacket);
                        });
                        _this.config = config;
                        return _this;
                    }
                    ShadowPortfolioUncertaintyChartMaker.prototype.makeAllSeries = function (portfolioUncData, extractor) {
                        var _a = _super.prototype.makeAllSeries.call(this, portfolioUncData, extractor), series = _a.series, firstXValue = _a.firstXValue;
                        var allShadowSeries = _super.prototype.makeAllSeriesForCurve.call(this, portfolioUncData.shadow, extractor);
                        var shadowSeries = allShadowSeries.series;
                        var shadowFirstXValue = allShadowSeries.firstXValue;
                        series = series.concat(shadowSeries);
                        firstXValue = firstXValue < shadowFirstXValue ? firstXValue : shadowFirstXValue;
                        return { series: series, firstXValue: firstXValue };
                    };
                    return ShadowPortfolioUncertaintyChartMaker;
                }(PortfolioUncertaintyChartMaker));
                metalog.ShadowPortfolioUncertaintyChartMaker = ShadowPortfolioUncertaintyChartMaker;
                var PointExtractor = /** @class */ (function () {
                    function PointExtractor() {
                    }
                    PointExtractor.prototype.yAxisDefinition = function () {
                        return {
                            title: {
                                text: this.yAxisDescriptor()
                            },
                            labels: {
                                enabled: false
                            },
                            lineWidth: 0,
                            crosshair: true
                        };
                    };
                    return PointExtractor;
                }());
                metalog.PointExtractor = PointExtractor;
                var CDFPointExtractor = /** @class */ (function (_super) {
                    __extends(CDFPointExtractor, _super);
                    function CDFPointExtractor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CDFPointExtractor.prototype.curveToPoints = function (points) {
                        return points.map(function (point) {
                            return [point.cdfPoint.x, point.cdfPoint.y];
                        });
                    };
                    CDFPointExtractor.prototype.descriptor = function () {
                        return "CDF";
                    };
                    CDFPointExtractor.prototype.yAxisDescriptor = function () {
                        return "Probability";
                    };
                    CDFPointExtractor.prototype.title = function () {
                        return "Cumulative Distribution Function";
                    };
                    CDFPointExtractor.prototype.yAxisDefinition = function () {
                        var answer = _super.prototype.yAxisDefinition.call(this);
                        answer.max = 1;
                        answer.labels = {
                            formatter: function () {
                                return this.value * 100 + '%';
                            }
                        };
                        return answer;
                    };
                    CDFPointExtractor.prototype.yAxisTenFiftyNinetyValues = function (distribution) {
                        return {
                            ten: 0.1,
                            fifty: 0.5,
                            ninety: 0.9
                        };
                    };
                    return CDFPointExtractor;
                }(PointExtractor));
                metalog.CDFPointExtractor = CDFPointExtractor;
                var PDFPointExtractor = /** @class */ (function (_super) {
                    __extends(PDFPointExtractor, _super);
                    function PDFPointExtractor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PDFPointExtractor.prototype.curveToPoints = function (points) {
                        return points.map(function (point) {
                            return [point.pdfPoint.x, point.pdfPoint.y];
                        });
                    };
                    PDFPointExtractor.prototype.descriptor = function () {
                        return "PDF";
                    };
                    PDFPointExtractor.prototype.yAxisDescriptor = function () {
                        return "PDF(y)";
                    };
                    PDFPointExtractor.prototype.title = function () {
                        return "Probability Density Function";
                    };
                    PDFPointExtractor.prototype.yAxisTenFiftyNinetyValues = function (distribution) {
                        return {
                            ten: distribution.pdf(0.1),
                            fifty: distribution.pdf(0.5),
                            ninety: distribution.pdf(0.9)
                        };
                    };
                    return PDFPointExtractor;
                }(PointExtractor));
                metalog.PDFPointExtractor = PDFPointExtractor;
            })(metalog = acts.metalog || (acts.metalog = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.metalog;
//# sourceMappingURL=portfolioUncertainty-chart-maker.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/portfolio-uncertainty/app/js/logic/portfolioUncertainty-chart-maker.js